"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseMoveCollectionItemsRequest = exports.collectionItemMovePath = exports.MAX_COLLECTION_MOVE_ITEMS = void 0;
const collectionSharing_1 = require("./collectionSharing");
const paths_1 = require("./paths");
exports.MAX_COLLECTION_MOVE_ITEMS = 20;
const collectionItemMovePath = (collectionId, operationId) => `${paths_1.firestorePaths.collection(collectionId)}/itemMoves/${(0, paths_1.requireOperationId)(operationId)}`;
exports.collectionItemMovePath = collectionItemMovePath;
const parseMoveCollectionItemsRequest = (value) => {
    if (!value || typeof value !== 'object' || Array.isArray(value))
        throw new Error('Invalid move.');
    const input = value;
    if (Object.keys(input).some((key) => ![
        'sourceCollectionId',
        'destinationCollectionId',
        'destinationLocationId',
        'operationId',
        'itemIds',
        'sourceShareId',
        'destinationShareId',
        'destinationTagIds',
        'sourceLinkToken',
        'destinationLinkToken',
    ].includes(key)))
        throw new Error('Unknown move field.');
    for (const key of [
        'sourceCollectionId',
        'destinationCollectionId',
        'destinationLocationId',
        'operationId',
    ]) {
        if (typeof input[key] !== 'string')
            throw new Error('Invalid move identity.');
    }
    const sourceCollectionId = input.sourceCollectionId;
    const destinationCollectionId = input.destinationCollectionId;
    const destinationLocationId = input.destinationLocationId;
    paths_1.firestorePaths.collection(sourceCollectionId);
    paths_1.firestorePaths.location(destinationCollectionId, destinationLocationId);
    if (sourceCollectionId === destinationCollectionId)
        throw new Error('Choose another collection.');
    if (!Array.isArray(input.itemIds) ||
        input.itemIds.length < 1 ||
        input.itemIds.length > exports.MAX_COLLECTION_MOVE_ITEMS)
        throw new Error('Invalid move size.');
    const itemIds = input.itemIds
        .map((id) => {
        if (typeof id !== 'string')
            throw new Error('Invalid item identity.');
        paths_1.firestorePaths.item(sourceCollectionId, id);
        return id;
    })
        .sort();
    if (new Set(itemIds).size !== itemIds.length)
        throw new Error('Duplicate item.');
    const scopes = Object.fromEntries(['sourceShareId', 'destinationShareId']
        .filter((key) => input[key] !== undefined)
        .map((key) => [key, (0, paths_1.requireOperationId)(input[key])]));
    const tokens = {};
    for (const side of ['source', 'destination']) {
        const token = input[`${side}LinkToken`];
        if (token !== undefined) {
            if (!input[`${side}ShareId`] ||
                typeof token !== 'string' ||
                !token ||
                token.length > 300)
                throw new Error('Invalid link credential.');
            tokens[`${side}LinkToken`] = token;
        }
    }
    return {
        ...scopes,
        ...tokens,
        ...(input.destinationTagIds === undefined
            ? {}
            : { destinationTagIds: (0, collectionSharing_1.parseTagIds)(input.destinationTagIds) }),
        sourceCollectionId,
        destinationCollectionId,
        destinationLocationId,
        itemIds,
        operationId: (0, paths_1.requireOperationId)(input.operationId),
    };
};
exports.parseMoveCollectionItemsRequest = parseMoveCollectionItemsRequest;
